import api from "./api";

export const fetchReconciliationSummary = (params = {}) =>
  api.get("/admin/reconciliation/", { params });

export const fetchProjectReconciliation = (projectId) =>
  api.get(`/admin/reconciliation/projects/${projectId}/`);

export const backfillProjectFundLedger = (projectId, { dryRun = true } = {}) =>
  api.post(`/admin/reconciliation/projects/${projectId}/backfill/`, { dry_run: dryRun });

export const repairProjectCapTable = (projectId, { dryRun = true } = {}) =>
  api.post(`/admin/reconciliation/projects/${projectId}/repair-cap-table/`, { dry_run: dryRun });

export const fetchReconciliationRuns = () => api.get("/admin/reconciliation/runs/");

export const fetchReconciliationRunDetail = (runId) => api.get(`/admin/reconciliation/runs/${runId}/`);

export const triggerReconciliationJob = (payload = {}) =>
  api.post("/admin/reconciliation/run-job/", payload);
